// extracted by mini-css-extract-plugin
export var actionButton = "_r6-0";
export var actionMenuContainer = "_r6-i";
export var bubble = "_r6-2";
export var bubbleActionMenu = "_r6-j";
export var bubbleContext = "_r6-6";
export var bubbleItems = "_r6-7";
export var customer = "_r6-3";
export var divider = "_r6-8";
export var fileList = "_r6-9";
export var hiddenComment = "_r6-o";
export var infoAbove = "_r6-a";
export var internal = "_r6-4";
export var lightActionButton = "_r6-1";
export var link = "_r6-b";
export var merchant = "_r6-5";
export var message = "_r6-c";
export var profilePicture = "_r6-e";
export var quillToolbarContainer = "_r6-f";
export var senderDate = "_r6-g";
export var senderDateCustomer = "_r6-h";
export var senderName = "_r6-d";
export var time = "_r6-k";
export var uploadedImage = "_r6-l";
export var username = "_r6-m";
export var xsmall = "_r6-n";